function getNetworkName<T extends { id: string; name: string }>(
  networks: Array<T> | undefined,
  id: string,
) {
  const name = networks?.find((network) => network.id === id)?.name
  if (!name) {
    throw new Error(`Network name with id ${id} was not found`)
  }
  return name
}

export default getNetworkName
